import { cn } from "../lib/utils"

// Define information variants with icons and colors
const informationVariants = {
  success: {
    icon: "fa-solid fa-circle-check",
    bgColor: "bg-green-50",
    borderColor: "border-green-500",
    iconColor: "text-green-500",
    titleColor: "text-green-900",
    descriptionColor: "text-green-700",
  },
  warning: {
    icon: "fa-solid fa-triangle-exclamation",
    bgColor: "bg-yellow-50",
    borderColor: "border-yellow-500",
    iconColor: "text-yellow-500",
    titleColor: "text-yellow-900",
    descriptionColor: "text-yellow-700",
  },
  error: {
    icon: "fa-solid fa-circle-exclamation",
    bgColor: "bg-red-50",
    borderColor: "border-red-500",
    iconColor: "text-red-500",
    titleColor: "text-red-900",
    descriptionColor: "text-red-700",
  },
  info: {
    icon: "fa-solid fa-circle-info",
    bgColor: "bg-blue-50",
    borderColor: "border-blue-500",
    iconColor: "text-blue-500",
    titleColor: "text-blue-900",
    descriptionColor: "text-blue-700",
  },
}

const Information = ({ variant = "info", title, description, className }) => {
  const variantStyles = informationVariants[variant] || informationVariants.info

  return (
    <div
      className={cn(
        "flex gap-3 rounded-lg border-l-4 p-4",
        variantStyles.bgColor,
        variantStyles.borderColor,
        className,
      )}
    >
      <div className={cn("flex-shrink-0 text-xl", variantStyles.iconColor)}>
        <i className={variantStyles.icon}></i>
      </div>
      <div className="flex-1">
        {title && (
          <h3 className={cn("mb-1 font-semibold", variantStyles.titleColor)}>{title}</h3>
        )}
        {description && (
          <p className={cn("text-sm", variantStyles.descriptionColor)}>{description}</p>
        )}
      </div>
    </div>
  )
}

export default Information
